module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/82be34b98c2cdc3b0a96e05484ccbc2b.png";